import { OMNIBEES_CRS_ID } from "../../constants";
import { GC_RATEPLAN_SCREEN_SOURCE } from "./constants";

/**
 * Checks if a promo is an external Omnibees promo
 * @param {Object} promo - The promo object
 * @param {Object} selectedProperty - The selected property object
 * @returns {boolean} - True if promo is from Omnibees (htPromo === false AND crsId === 19)
 */
export const isOmnibeesExternalPromo = (promo, selectedProperty) => {
  return (
    promo?.htPromo === false && selectedProperty?.crsId === OMNIBEES_CRS_ID
  );
};

/**
 * A Campaign promo (promoType BUYER_CAMPAIGN): one a hotel opted into from a buyer
 * campaign. Hotel Trader manages its configuration, so on the Supplier Portal it is
 * always view-only (EO-1538).
 */
export const isCampaignPromo = (promo) =>
  [promo?.promoType, promo?._derivedRateMeta?.promoType].some(
    (type) => type?.toUpperCase() === "BUYER_CAMPAIGN"
  );
// The type alone decides it, never `campaignId` — matching metadata's
// BuyerCampaignDrEditGuard and the SDK's PromoExpiryRules.isBuyerCampaign. The
// metadata service also mints a campaignId as a plain grouping id for any promo
// created across several properties (DerivedRateService.createPromo), so an ordinary
// multi-property Custom promo carries one too. Pilot hotels: the list row carries the
// backend's promoType; after the detail fetch it is meta.promoType, kept under
// _derivedRateMeta.

/**
 * A promo created from the GC rate-plan screen. It is managed there, so on the
 * Supplier Portal it is view-only however it is opened — row menu or name.
 */
export const isGcRateplanPromo = (promo) =>
  promo?.source === GC_RATEPLAN_SCREEN_SOURCE;

/*
 * hasEarnedRevenue lived here. Deleted with its last caller: the revenue gate moved into
 * PromoCodeServiceImpl, which nulls expiryStatus for a promo that earned nothing. Leaving the helper
 * behind would leave its docblock asserting a rule this app no longer applies, which is the kind of
 * thing a later reader wires back up.
 */
